import { render } from "./SimmerEffect.vue?vue&type=template&id=8702774e&scoped=true"
import script from "./SimmerEffect.vue?vue&type=script&lang=js"
export * from "./SimmerEffect.vue?vue&type=script&lang=js"

import "./SimmerEffect.vue?vue&type=style&index=0&id=8702774e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8702774e"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/SimmerEffect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8702774e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8702774e', __exports__)) {
    api.reload('8702774e', __exports__)
  }
  
  module.hot.accept("./SimmerEffect.vue?vue&type=template&id=8702774e&scoped=true", () => {
    api.rerender('8702774e', render)
  })

}


export default __exports__